<template>
  <section id="sig">
    <h2>Signifiers</h2>

    <!-- 显示所有的描述内容 -->
    <div v-for="(description, imageName) in descriptions" :key="imageName" class="description-item">
      <h3>{{ removeFileExtension(imageName) }}</h3> <!-- 移除文件后缀的图片文件名 -->
      <p>{{ description.description }}</p> <!-- 描述内容 -->
    </div>
  </section>
</template>

<script>
// 导入 JSON 文件
import descriptions from '@/assets/images/description.json';

export default {
  name: 'WorkDescriptions',
  data() {
    return {
      descriptions: descriptions,  // 从 JSON 文件中获取数据
    };
  },
  methods: {
    // 移除文件名的后缀（例如 .jpg）
    removeFileExtension(imageName) {
      return imageName.replace(/\.[^/.]+$/, ""); // 正则表达式移除文件扩展名
    }
  }
};
</script>

<style scoped>
#sig {
  display: flex;
  flex-direction: column;
  padding-top: 5vw;
  background-color: #000;
  color: #0026ff;
  text-align: center;
  justify-content: center;
  align-items: center;
}

h2 {
  margin-top: 10vh;
  margin-bottom: 1vh;
  font-size: 3vh;
}

.description-item {
  margin-bottom: 0.1vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.description-item h3 {
  margin-bottom: -0.5vh;
  font-size: 2vh;
  color: #f4f4f4;
  max-width: 80vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.description-item p {
  font-size: 1.5vh;
  color: #ccc;
  max-width: 80vw;
}
</style>
